import { render, staticRenderFns } from "./installPlugin.vue?vue&type=template&id=97248fc4&scoped=true&"
import script from "./installPlugin.vue?vue&type=script&lang=js&"
export * from "./installPlugin.vue?vue&type=script&lang=js&"
import style0 from "./installPlugin.vue?vue&type=style&index=0&id=97248fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97248fc4",
  null
  
)

export default component.exports